// extracted by mini-css-extract-plugin
export var banner = "GameConceptStoreIdBanner-module__banner___t+-HO";
export var title = "GameConceptStoreIdBanner-module__title___SGWLN";